import { request } from "@/composables/useFetch";

const prefix = "/v1";
export function login(data) {
    return request(`${prefix}/login` , {method: "POST", body: data});
}

export function logout() {
    return request(`${prefix}/logout`);
}
